import { Injectable, inject } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { EnvironmentService } from '@app/core/services/environment.service';

export type FeedbackRating = 0 | 1; // 0 = Positive, 1 = Negative

const headers = new HttpHeaders({
  'Content-Type': 'application/json',
});

@Injectable({
  providedIn: 'root'
})
export class ChatActionsService {
  private http = inject(HttpClient);
  private base = this.envService.env.apiUrl;

  constructor(private envService: EnvironmentService) { }

  confirmAction(conversationId: string, pendingActionId: string) {
    return this.http.post(
      `${this.base}/Chatbot/Conversations/${conversationId}/Actions/${pendingActionId}/Confirm`,
      {}
    );
  }

  submitFeedback(conversationId: string, messageId: string, rating: FeedbackRating, comment?: string) {
    return this.http.post(
      `${this.base}/Chatbot/Conversations/${conversationId}/Messages/${messageId}/Feedback`,
      { rating, comment }
    );
  }
}
